import { motion } from "framer-motion";

// Masked line-by-line reveal. Pass array of lines.
const lineVariants = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: 0,
    transition: { duration: 0.85, ease: [0.16, 1, 0.3, 1], delay: 0.15 + i * 0.12 },
  }),
};

export const KineticLines = ({ lines, className = "", lineClassName = "", testId }) => {
  return (
    <span data-testid={testId} className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            custom={i}
            variants={lineVariants}
            initial="hidden"
            animate="visible"
            className={`block ${lineClassName}`}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Word stagger reveal triggered on view
const wordVariants = {
  hidden: { opacity: 0, y: 18, filter: "blur(6px)" },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.5, ease: [0.16, 1, 0.3, 1], delay: i * 0.03 },
  }),
};

export const KineticWords = ({ text, className = "", testId }) => {
  const words = text.split(" ");
  return (
    <motion.span
      data-testid={testId}
      className={`inline ${className}`}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-10% 0px" }}
    >
      {words.map((w, i) => (
        <motion.span key={i} custom={i} variants={wordVariants} className="inline-block">
          {w}&nbsp;
        </motion.span>
      ))}
    </motion.span>
  );
};
